var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFireworks = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6F20",
  d: "M18 2c-1.1 4.5-3.2 7.8-6.3 10.2S5.3 15.8 2 16c3.3.2 6.6 1.4 9.7 3.8S16.9 25.5 18 30c1.1-4.5 3.2-7.8 6.3-10.2s6.4-3.6 9.7-3.8c-3.3-.2-6.6-1.4-9.7-3.8S19.1 6.5 18 2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFireworks);
export default ForwardRef;